module.exports = __webpack_public_path__ + "static/media/Aalidhra3a1.d6ffa50e.jpg";